import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../services/api.service';
import { FormService } from '../services/form.service';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  constructor(
    private _apiSvc: ApiService,
    private _formSvc: FormService
  ) { }

  /**
   * Generate report and download generated file
   * @param reportEp 
   * @param formValues 
   * @param reportFileName 
   * @returns 
   */
  generate(reportEp: string, formValues: any, reportFileName: string): Observable<any> {

    const payload = {};

    // add only properties with values to payload
    Object.keys(formValues).forEach((k) => {
      if (formValues[k] !== null && formValues[k] !== '') {
        payload[k] = formValues[k];
      }
    });

    // set the report file extension
    let reportFileExt = 'pdf';
    if (payload['OutputFormat'] === 'EXCEL') {
      reportFileExt = 'xls'
    }

    return this._apiSvc.getFile(reportEp, payload, reportFileName)
      .pipe(
        map((res: any) => {
          this._formSvc.downloadGeneratedFile(res, reportFileName, reportFileExt);
        })
      );

  }

  /**
   * Process report api errors
   * @param err 
   */
  processErrors(err: any): any {

    return new Promise((resolve: any, _reject: any) => {

      err.error.text()
        .then((data: any) => {

          const errors = {
            fieldErrors: null,
            formErrors: null
          };

          const res = JSON.parse(data);
    
          if (res.Errors) {
            errors.formErrors = res.Errors;
          }
    
          if (res.FieldErrors) {
    
            let fe = {};
            res.FieldErrors.forEach((e: any) => {
              fe[e.Field] = e.Message;
            });
            errors.fieldErrors = fe;
    
          }
    
          resolve(errors);
    
        });

    });

  }

}
